
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M450 336.56h-36.86l-81.01-136.25a10.58 10.58 0 00-9.09-5.17h-15.99c-3.73 0-7.18 1.97-9.09 5.17l-74.85 125.9a21.15 21.15 0 01-18.18 10.34h-39.99c-7.46 0-14.36-3.93-18.18-10.34L50 163.44h36.86l81.01 136.26c1.9 3.2 5.36 5.17 9.09 5.17h15.98c3.71 0 7.15-1.94 9.07-5.12l74.88-125.95a21.15 21.15 0 0118.18-10.34h39.99c7.45 0 14.36 3.93 18.17 10.34l96.78 162.77zm-82.32-52.86v-.85c-46.51 0-52.01-5.5-52.01-52.01h-1.7c0 46.51-5.5 52.01-52.01 52.01v1.7c46.51 0 52.01 5.5 52.01 52.01h1.7c0-46.51 5.5-52.01 52.01-52.01v-.85z","fill":"#3d2562"}})])
          )
        }
      }
    